import classes from "../forms/forms.module.css";
import Datetime from "react-datetime";

const InputDate = ({value, onChange, text, placeholder, required}) => {

    const handleChange = e => {

        if (typeof e === "object" && e.toDate) {
            onChange(e.toDate());
        } else if (typeof e === "string") {
            const parsed = new Date(e);
            if (!isNaN(parsed)) {
                onChange(parsed);
            } else {
                onChange(null);
            }
        }
    };

    return (
        <div>
            <label className={classes.label}>{text} {required && <b className={classes.required}>*</b>}
            </label>
            <div className={classes.datetimeWrapper}>
                <Datetime
                    locale={'ru'}
                    placeholder={`${placeholder}`}
                    dateFormat="YYYY-MM-DD"
                    timeFormat="HH:mm"
                    value={value}
                    onChange={handleChange}
                    inputProps={{
                        readOnly: true,
                        placeholder: {placeholder},
                    }}
                />
                <text className={classes.calendarIcon}>📅</text>
            </div>
            <style>{`
                span{
        margin-left: 5px;
        margin-bottom: -2px;
        position: relative;
        background: none;
        border-radius: 3px;
    }
    
  
`           }</style>
        </div>
    )
};

export default InputDate;